var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RemoveUser, SaveChanges, ShareDialogState, UpdateUserPermissions } from '../state/share-dialog.state';
import { CurrentUser } from '../../../../common/auth/current-user';
var EntriesAccessTableComponent = /** @class */ (function () {
    function EntriesAccessTableComponent(store, currentUser) {
        this.store = store;
        this.currentUser = currentUser;
    }
    EntriesAccessTableComponent.prototype.updateUserPermissions = function (user, newPermissions) {
        this.store.dispatch(new UpdateUserPermissions(user, newPermissions));
    };
    EntriesAccessTableComponent.prototype.removeUser = function (user) {
        this.store.dispatch(new RemoveUser(user));
    };
    EntriesAccessTableComponent.prototype.saveChanges = function () {
        this.store.dispatch(new SaveChanges());
    };
    EntriesAccessTableComponent.prototype.trackByUser = function (index, user) { return user.id; };
    __decorate([
        Select(ShareDialogState.usersWithAccess),
        __metadata("design:type", Observable)
    ], EntriesAccessTableComponent.prototype, "users", void 0);
    __decorate([
        Select(ShareDialogState.dirty),
        __metadata("design:type", Observable)
    ], EntriesAccessTableComponent.prototype, "dirty", void 0);
    __decorate([
        Select(ShareDialogState.loading),
        __metadata("design:type", Observable)
    ], EntriesAccessTableComponent.prototype, "loading$", void 0);
    return EntriesAccessTableComponent;
}());
export { EntriesAccessTableComponent };
